/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFinalResponse, InitApiType, EndPointsNames } from '../../types';
import { post } from './Auth0Api';

const API_DOMAIN: EndPointsNames = 'ApiAuth0';
const ENDPOINT_API_PATH = '/oauth/token/';

type ParamsTypes = {
  client_id: string;
  client_secret: string;
  audience: string;
  grant_type: string;
};

const call = async (params: ParamsTypes): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const init: InitApiType = {
      body: {
        ...params,
      },
    };
    const response = await post(API_DOMAIN, ENDPOINT_API_PATH, init);

    result.success = true;
    result.data = response.response;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call };
